import moment from 'moment';

export const storeData = ({ basePath, pathParam, id, urlParams, data, appType }) => {
  const createdAt = moment().valueOf();

  try {
    const key = prepareLocalStorageKey({ basePath, pathParam, id, urlParams, appType });
    const storageString = prepareLocalStorageData({ createdAt, data });
    localStorage.setItem(key, storageString);
  } catch (e) {}
};

export const getData = ({ basePath, pathParam, id, urlParams, appType }) => {
  try {
    const key = prepareLocalStorageKey({ basePath, pathParam, id, urlParams, appType });
    const storageString = localStorage.getItem(key);
    if (isDataValid(storageString)) {
      return JSON.parse(storageString).data;
    }
    return null;
  } catch (e) {
    return null;
  }
};

const prepareLocalStorageData = ({ createdAt, data }) => {
  const storageString = JSON.stringify({
    data: data,
    createdAt: createdAt,
  });
  return storageString;
};

const prepareLocalStorageKey = ({ basePath, pathParam, id, urlParams, appType }) => {
  const keyUrlParams = JSON.stringify(urlParams);

  // when we need a simple key, used for sifranti and obcine
  if (basePath && !pathParam && !id && !urlParams && !appType) {
    return basePath;
  }

  // all other data
  const key = pathParam
    ? `${basePath}/${id}/${pathParam}/${keyUrlParams}-${appType}`
    : `${basePath}/${id}/${keyUrlParams}-${appType}`;
  return key.replace(/"/g, '');
};

const isDataValid = storageString => {
  if (!storageString) {
    // if data is null
    return false;
  }
  const objectToCheck = JSON.parse(storageString);
  let timeToCompare = moment().hour(3);
  if (moment().isBefore(timeToCompare)) {
    timeToCompare.subtract(1, 'days');
  }
  // if data is too old, return false
  return moment(objectToCheck.createdAt).isAfter(timeToCompare);
};

export const clearStorage = () => {
  localStorage.clear();
};

export const clearEVCache = () => {
  const data = localStorage.valueOf();
  const keysToDelete = Object.keys(data)
    .map(key => {
      if (key.includes('-EV')) {
        return key;
      }
      return null;
    })
    .filter(key => key);

  keysToDelete.forEach(key => {
    localStorage.removeItem(key);
  });
};
